import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ip-shared-expandable-text',
  standalone: true,
  imports: [CommonModule],
  templateUrl: 'expandable-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableTextComponent {
  @Input({ required: true }) shortText!: string;
  @Input({ required: true }) fullText!: string;
  expanded = false;

  expand() {
    this.expanded = true;
  }
}
